import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import {
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit'
import OnboardingLeadsPanel from './OnboardingLeadsPanel.component'
import Store from './OnboardingLeads.store'

import './OnboardingLeadsCard.scss'

// Shown on the dashboard for the first ONBOARDING_LEADS_WINDOW_DAYS after onboarding,
// until the agent's first lead vendor transfer or a dismissal on this device.
const OnboardingLeadsCard = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (Store.isEligible) Store.load()
    return () => Store.end()
  }, [])

  const close = () => {
    setIsOpen(false)
    Store.end()
  }

  // A transfer made from the panel hides the card, but the open panel stays up to show the outcome.
  if (!Store.showCard && !isOpen) return null

  return (
    <>
      {Store.showCard ? (
        <div id='OnboardingLeadsCardComponent'>
          <div className='olc-icon' aria-hidden='true'>
            <MDBIcon icon='wallet' />
          </div>
          <div className='olc-body'>
            <h5>Put your BUCK$ to work!</h5>
            <p>
              Your onboarding BUCK$ are ready to spend on leads. Transfer them to a lead vendor in a couple of clicks.
            </p>
            <div className='olc-actions'>
              <MDBBtn
                color='indigo'
                onClick={() => {
                  Store.armTransfer()
                  setIsOpen(true)
                }}
              >
                Spend My BUCK$ on Leads
              </MDBBtn>
              <button type='button' className='olc-dismiss' onClick={() => Store.dismiss()}>
                Dismiss
              </button>
            </div>
          </div>
        </div>
      ) : null}
      <MDBModal open={isOpen && !Store.isBuying} onClose={close} staticBackdrop>
        <MDBModalDialog
          size='lg'
          scrollable
          className='modal-fullscreen-sm-down onboarding-leads-modal'
          data-transfer-form={Store.transferFormVersion}
        >
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Lead Vendors</MDBModalTitle>
              <MDBBtn type='button' className='btn-close' color='none' aria-label='Close' onClick={close}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <OnboardingLeadsPanel />
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn type='button' color='default' onClick={close}>
                Close
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  )
}

export default observer(OnboardingLeadsCard)
